export default __webpack_public_path__ + "static/media/rain-4-night.7d5760ca.svg";